import * as React from 'react';
import NumberFormat from 'react-number-format';
import ModernDatepicker from 'react-modern-datepicker';
import { IClaimListItem, ILossType } from '../../../../interfaces/KPClaimList/KPClaimListInterfaces';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import KPDropdown from '../KPDropdown/KPDropdown';
import './KPClaimList.css'
import KPSelectableListItem from '../KPSelectableList/KPSelectableListItem';

class KPClaimListItem extends React.PureComponent<IClaimListItem, any> {
    constructor(props) {
        super(props);

        this.state = {
            lossType: this.props.lossType ?? null,
            lossTypes: this.props.lossTypes ?? [],
            selectableItems: [],
            currencySymbol: this.props.currencySymbol,
            maxDate: new Date(),
        };

        this.setLossTypes = this.setLossTypes.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleLossTypeChange = this.handleLossTypeChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChangeCurrentPremises = this.handleChangeCurrentPremises.bind(this);
    }

    componentDidMount() {
        if (this.state.lossTypes.length > 0) {
            this.setLossTypes({ ...this.state }.lossTypes);
        }
    }

    setLossTypes(lossTypes: ILossType[]) {
        let selectableItems: IDropdownData[] = [];

        lossTypes.forEach(item => {
            selectableItems.push({
                id: item.id,
                description: item.description,
                image: "",
                productName: item.description
            } as IDropdownData);
        });

        this.setState({ lossTypes, selectableItems });
    }

    handleDateChange(date: Date) {
        if (this.props.handleDateChange) {
            this.props.handleDateChange(this.props.id, date);
        }
    }

    handleLossTypeChange(e: any) {
        if (this.props.handleLossTypeChange) {
            this.props.handleLossTypeChange(this.props.id, e);
        }
    }

    handleValueChange(e: any) {
        let value = e.target.value.toString().substring(this.state.currencySymbol.length);
        if (this.props.handleValueChange) {
            this.props.handleValueChange(this.props.id, (value !== "" ? value : null));
        }
    }

    handleChangeCurrentPremises() {
        if (this.props.handleChangeCurrentPremises) {
            this.props.handleChangeCurrentPremises(this.props.id);
        }
    }

    handleRemove() {
        if (this.props.handleRemove) {
            this.props.handleRemove();
        }
    }

    public render() {
        let dateError = (this.props.submitted && (this.props.date === null || this.props.date === undefined));
        let typeError = (this.props.submitted && (this.props.lossType === null || this.props.lossType === undefined));
        let valueError = (this.props.submitted && (this.props.value === null || this.props.value === undefined));
        
        return (
            <>
                <div className="row ssp-claim-list-item">
                    <div className="col-md-1 mb-4">
                        <div className="ssp-index-circle align-center">
                            <span>
                                {this.props.index + 1}
                            </span>
                        </div>
                    </div>
                    <div className="col-md-3 mb-4">
                        <div className={"form-group noma " + (dateError ? " has-error" : "")}>
                            <ModernDatepicker
                                id={"txtDate" + this.props.id}
                                date={this.props.date}
                                format={'DD-MM-YYYY'}
                                showBorder={true}
                                onChange={(date) => this.handleDateChange(date)}
                                placeholder="Incident date"
                                maxDate={this.state.maxDate}
                                className="ssp-calendar-input calendar-inline-icon"
                            />
                            {dateError &&
                                <div className="form-inline-error">Please choose a date.</div>
                            }
                        </div>
                    </div>
                    <div className="col-md-3 mb-4">
                        <div className={"form-group noma " + (typeError ? " has-error" : "")}>
                            <KPDropdown
                                id={"lstLossType" + this.props.id}
                                isBordered={true}
                                showLabelAfterSelection={false}
                                showLabelInside={false}
                                showLabelOutside={false}
                                labelAfterSelection=""
                                label="Type of loss"
                                title=""
                                data={this.state.lossTypes}
                                selectedValue={this.props.lossType}
                                handleSelection={(e) => this.handleLossTypeChange(e)}
                            />
                            {typeError &&
                                <div className="form-inline-error">Please select an option.</div>
                            }
                        </div>
                    </div>
                    <div className="col-md-3 mb-4">
                        <div className={"form-group noma " + (valueError ? " has-error" : "")}>
                            <div className="ssp-inputtextarea-input-element-container">
                                <NumberFormat
                                    id={"txtClaimValue" + this.props.id}
                                    name={"txtClaimValue" + this.props.id}
                                    placeholder="Total repair (or value lost)"
                                    thousandSeparator={true}
                                    thousandsGroupStyle="thousand"
                                    prefix={this.state.currencySymbol}
                                    value={this.props.value}
                                    disabled={false}
                                    readOnly={false}
                                    required={true}
                                    className="ssp-inputtextarea-input-element"
                                    onChange={(e) => this.handleValueChange(e)}
                                />
                            </div>
                            {valueError &&
                                <div className="form-inline-error">Please fill in this field.</div>
                            }
                        </div>
                    </div>
                    <div className="col-md-2 mb-4">
                        <div className={"form-group noma"}>
                            <div className="ssp-inputtextarea-input-element-container display-flex">
                                <KPSelectableListItem
                                    key={1}
                                    id={"currentPremises" + this.props.id}
                                    label="Current address"
                                    value="currentPremises"
                                    selected={this.props.currentPremises}
                                    className="checkboxGroup"
                                    required={false}
                                    disabled={false}
                                    handleSelect={(e) => this.handleChangeCurrentPremises()}
                                    selectOnLeft={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row nopa noma ssp-claim-list-item-devider">
                    {this.props.canRemove && !this.props.isExisting &&
                        <div className="col-12 nopa noma">
                            <div id="btnRemoveIncident" className="btn-remove-incident" onClick={ this.handleRemove }>
                                <img src="./Images/icon-remove-red-circle.svg" className="img-fluid btn-edit mr-2" /> Remove incident
                            </div>
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default KPClaimListItem